// UsagePatternChart.jsx
import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { Box, Paper, Typography } from "@mui/material";
import { PeakActivityIcon } from "../../../icons";

const UsagePatternChart = ({userPatterns}) => {
  const categories = userPatterns?.map(ele=>ele?.category);

  const data =  userPatterns?.map(ele=>ele?.count);

  const options = {
    chart: {
      type: "column",
    },
    title: {
      text: "Usage Pattern (24h)",
	  align: "left",
	  margin: 20,
      style: { fontSize: "16px", fontWeight: 500, },
    },

    xAxis: {
      categories,
    },

    yAxis: {
      min: 0,
      title: { text: "" },
    },

    plotOptions: {
      column: {
        borderRadius: 6,
        dataLabels: {
          enabled: true,
          style: {
            fontSize: "12px",
            fontWeight: "600",
            textOutline: "none",
          },
        },
      },
    },

    series: [
      {
        name: "Usage",
        data,
        color: "#4B8CF5",
      },
    ],

    legend: { enabled: false },
    credits: { enabled: false },
  };
  const total = (data || [])?.reduce((acc,curr)=>acc+curr,0)
  const result = {
    high: null,
    low: null,
    middle: null
  };

  userPatterns.forEach(ele => {
    // if (!ele?.count) return;

    if (!result.high || ele.count > result.high.count) {
      result.high = ele;
    }

    if (!result.low || ele.count < result.low.count) {
      result.low = ele;
    }
  });

  const avg =
    userPatterns.reduce((sum, e) => sum + (e.count || 0), 0) /
    userPatterns.length;

  result.middle = userPatterns.reduce((closest, e) => {
    if (!e?.count) return closest;
    if (!closest) return e;

    return Math.abs(e.count - avg) < Math.abs(closest.count - avg)
      ? e
      : closest;
  }, null);

  const labelFormat = {
    high:{color: '#155DFC',label:"Highest"},
    low:{color: '#00A63E',label:"Lowest"},
    middle:{color: '#4A5565',label:"Moderate"},
  }

  return (
    <Box sx={{ p: 2, borderRadius: 2, boxShadow:'none', border:'1px solid #E8E8E8', overflow:'hidden', width:'100%', }}>
      {
        total ? <>
          <HighchartsReact highcharts={Highcharts} options={options} />
          <Box sx={{ mt: 3 }}>
            <Typography sx={{ fontWeight: 400, color: '#6A7282', fontSize: '14px', display: 'flex', alignItems: 'center', gap: 1, }}>
              <PeakActivityIcon /> Peak Activity
            </Typography>
            <Box sx={{ mt: 1 }}>
              {Object.entries(result)?.filter(([a,b],)=>b)?.map(([key,value])=><Typography sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: '#4A5565', fontSize: '14px' }}>
                {value?.time} ({value?.category?.split("-")?.join(" - ")}): <Typography variant="span" sx={{ color: labelFormat?.[key]?.color, fontSize: '16px' }}>{labelFormat?.[key]?.label}</Typography>
              </Typography>)}
              {/* {Boolean(result?.high) && <Typography sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: '#4A5565', fontSize: '14px' }}>
                Evening ({result?.high?.category}): <Typography variant="span" sx={{ color: '#00A63E', fontSize: '16px' }}>Highest</Typography>
              </Typography>} */}
              
              {/* <Typography sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: '#4A5565', fontSize: '14px' }}>
                Afternoon (12 PM - 4 PM): <Typography variant="span" sx={{ color: '#155DFC', fontSize: '16px' }}>Moderate</Typography>
              </Typography>
              <Typography sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', color: '#4A5565', fontSize: '14px' }}>
                Night (12 AM - 6 AM): <Typography variant="span" sx={{ color: '#4A5565', fontSize: '16px' }}>Lowest</Typography>
              </Typography> */}
            </Box>
          </Box>
        </>
          : <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography variant="body1" color="text.secondary">
              No data available
            </Typography>
          </Box>
      }
    </Box>
  );
};

export default UsagePatternChart;
